// extracted by mini-css-extract-plugin
export default {"container":"InternalOverview_container__hs552"};